<div class="container">
    <div class="devis">
        <div class="titre">Comparateur d'assurance</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-comparer.webp"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-comparer.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://comparer-assurance-pret.april.fr/intro?LI=97729AAB-ABEA-42E2-AB5F-%206EDE2E94DFC1&CO=CO:23804&canal=ebusiness&nohf=true&AON_ID=RmN0akJjaEpFNGxua0ZpVW54Y0hKUT09"
                target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Assurance Auto</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-auto.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-auto.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/auto" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Complémentaire Santé</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-sante.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-sante.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/health" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Mon assurance de prêt en ligne</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-pret2.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-pret2.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://tarif-assurance-pret-immobilier.april.fr/?LI=97729AAB-ABEA-42E2-AB5F-%206EDE2E94DFC1&CO=23804&AON_ID=RmN0akJjaEpFNGxua0ZpVW54Y0hKUT09"
                target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>
    
    <div class="devis">
        <div class="titre">Assurance emprunteur</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-pret.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-pret.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/loan" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Capital décès</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-capital-deces.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-capital-deces.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/deces" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Garantie Obsèques</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-garantie-obseques.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-garantie-obseques.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/decease" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Garantie Accident de la vie</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-accidents.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-accidents.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/gav" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Indemnités journalières hospitalières</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/hopital.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/hopital.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/ijh" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Assurance Multirisque Habitation</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-habitation.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-habitation.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/mrh" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Prévoyance pro</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-pro.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-pro.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/ij" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Protection juridique</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-juridique.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-juridique.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/pj" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Assurance chiens & chats</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-animal.webp"
                    alt="devis"                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-animal.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/animal" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

    <div class="devis">
        <div class="titre">Assurance Dépendance</div>
        <div class="image">
            <picture>
                <!-- WebP -->
                <source
                    type="image/webp"
                    srcset="./../../../assets/webp/devis-dep.webp"
                    alt="devis"
                >
                <!-- Fallback -->
                <img src="./../../../assets/devis-dep.png" alt="devis">
            </picture>
        </div>
        <div class="bouton">
            <a href="https://sanceypatrimoines.oggo-data.net/iform/dependence" target="_blank">Obtenir le devis en ligne
            </a>
        </div>
    </div>

</div>